// extracted by mini-css-extract-plugin
module.exports = {"root":"Home_root__3LwQS","desc":"Home_desc__224nn","btnContainer":"Home_btnContainer__3qQ19","btn":"Home_btn__iJrtB"};